// Calculate HSL luminance: https://www.niwa.nu/2013/05/math-behind-colorspace-conversions-rgb-hsl/
const calculateLuminance = ({
  r,
  g,
  b,
}: {
  r: number;
  g: number;
  b: number;
}) => {
  r /= 255;
  g /= 255;
  b /= 255;

  return (Math.max(r, g, b) + Math.min(r, g, b)) / 2;
};

export default calculateLuminance;
